import { RoleLabelsMap } from './types'

export const roleLabelsMap: RoleLabelsMap = {
  admin: {
    label: 'Admin',
    chipColor: 'primary',
  },
  employee: {
    label: 'Empleado',
    chipColor: 'default',
  },
}
